class cartDiscountsApplier extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.input = this.querySelector('input');
		this.applyDiscountsBtn = this.querySelector('button');
		this.errorMessage = this.querySelector('#errorMessage');
		this.applyDiscountsListener = this.applyDiscounts.bind(this);
		this.updateButtonStateListener = this.updateButtonState.bind(this);
		this.onkeyupListener = this.onkeyup.bind(this);
		this.applyDiscountsBtn.addEventListener('click', this.applyDiscountsListener);
		this.input.addEventListener('input', this.updateButtonStateListener);
		this.input.addEventListener('keyup', this.onkeyupListener);
	}
	disconnectedCallback() {
		this.applyDiscountsBtn.removeEventListener('click', this.applyDiscountsListener);
		this.input.removeEventListener('input', this.updateButtonStateListener);
		this.input.removeEventListener('input', this.onkeyupListener);
	}

	applyDiscounts() {
		this.discountCode = this.input.value;
		if (!this.discountCode) {
			return;
		}
		const discountApplyUrl = Shopify.routes.root + 'checkout?discount=' + this.discountCode + '&skip_shop_pay=true';
		this.setButtonLoading();
		fetch(discountApplyUrl)
			.then((response) => response.text())
			.then((data) => {
				// console.log('Success:', data);
				let response = this.extractErrors(data);
				if (response) {
					this.refreshCart();
				}
				this.resetButtonLoading();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
	onkeyup(event) {
		if (event.key === 'Enter') {
			this.applyDiscounts();
		}
	}
	setButtonLoading() {
		this.applyDiscountsBtn.setAttribute('disabled', 'disabled');
		this.applyDiscountsBtn.setAttribute('aria-busy', 'true');
	}

	resetButtonLoading() {
		this.applyDiscountsBtn.removeAttribute('disabled');
		this.applyDiscountsBtn.removeAttribute('aria-busy');
	}

	refreshCart() {
		fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response) => {
			const cartContent = await response.json();
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:updated', {
					bubbles: true,
					detail: {
						cart: cartContent,
					},
				}),
			);
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:refresh', {
					bubbles: true,
					detail: {
						cart: cartContent,
					},
				}),
			);
		});
	}

	extractErrors(response) {
		let reg = ['DISCOUNTS_CURRENTLY_INACTIVE', 'DISCOUNTS_NOT_FOUND', 'DISCOUNTS_NO_ENTITLED_LINE_ITEMS'];
		reg = new RegExp(reg.join('|'), 'i');

		let match = response.match(reg);
		if (match) {
			this.showErrorMessage();
			return false;
		} else {
			return true;
		}
	}

	showErrorMessage() {
		this.errorMessage.removeAttribute('hidden');
		setTimeout(() => {
			this.errorMessage.setAttribute('hidden', 'hidden');
		}, 5000);
	}

	updateButtonState(event) {
		if (event.target.value === '') {
			this.applyDiscountsBtn.removeAttribute('disabled');
		} else {
			this.applyDiscountsBtn.removeAttribute('disabled');
		}
	}
}

if (!window.customElements.get('cart-discounts-applier')) {
	window.customElements.define('cart-discounts-applier', cartDiscountsApplier);
}
